/*globals window */

define('carouselController',['jquery', 'rmlibrary/carousel'], function ($, RMCarousel) {
    var carousel;

    function init() {
        if ($(".rm-carousel").children().length < 2) return; // Don't enable the carousel if these is less than 2 banners.

        carousel = mod.carousel = new RMCarousel($(".rm-carousel"));
        carousel.options({
        	transitionTimer : 4,
        	transitionFunction : function (oldSlide, newSlide, delta) {
                var track = this.elem.children(".generatedTrack");
                var banners = track.children();
                var moveLeft = delta < 0;
                var next = newSlide % this.children;
                var children = this.children;
                if (next === 0 && !moveLeft) {
                    var lastElem = track.children().last();
                    track.css({
                        "-webkit-transition" : "",
                		"-moz-transition" : "",
                		"transition" : "",
                        "-webkit-transform": "translateX(" + (100 / this.children) + "%)",
                        "-moz-transform": "translateX(" + (100 / this.children) + "%)",
                        "transform": "translateX(" + (100 / this.children) + "%)"
                    });
                    lastElem.css({
                        "-webkit-transform": "translateX(" + (-100 * this.children) + "%)",
                        "-moz-transform": "translateX(" + (-100 * this.children) + "%)",
                        "transform": "translateX(" + (-100 * this.children) + "%)"
                    });
                    window.setTimeout(function () {
                        lastElem.css({
                            "-webkit-transform": "",
                            "-moz-transform": "",
                            "transform": ""
                        });
                    }, 550);
                } else if (moveLeft && next === children - 1) {
                    var firstElem = track.children().first();
                    track.css({
                        "-webkit-transition" : "",
                		"-moz-transition" : "",
                		"transition" : "",
                        "-webkit-transform": "translateX(-100%)",
                        "-moz-transform": "translateX(-100%)",
                        "transform": "translateX(-100%)"
                    });
                    firstElem.css({
                        "-webkit-transform": "translateX(" + (100 * this.children) + "%)",
                        "-moz-transform": "translateX(" + (100 * this.children) + "%)",
                        "transform": "translateX(" + (100 * this.children) + "%)"
                    });
                    window.setTimeout(function () {
                        firstElem.css({
                            "-webkit-transform": "",
                            "-moz-transform": "",
                            "transform": ""
                        });
                    }, 550);
                }
                window.setTimeout(function () {
                    track.css({
                        "-webkit-transition" : "all 0.5s ease-in-out",
                        "-moz-transition" : "all 0.5s ease-in-out",
                        "transition" : "all 0.5s ease-in-out",
                        "-webkit-transform": "translateX(" + (-100 * next / children) + "%)",
                        "-moz-transform": "translateX(" + (-100 * next / children) + "%)",
                        "transform": "translateX(" + (-100 * next / children) + "%)"
                    });
                }, 20);

                banners.attr("aria-hidden", "true");
                banners.eq(next).attr("aria-hidden", "false");
            },
            transitionClasses : {
        		"-webkit-transition" : "all 0.5s ease-in-out",
        		"-moz-transition" : "all 0.5s ease-in-out",
        		"transition" : "all 0.5s ease-in-out"
        	}
        });

        carousel.playToggle();
        carousel.enableSwipe(true);
        $(window).trigger('resize');
        window.setTimeout(function(){
    		carousel.generateDirectionalButtons(true);
    		carousel.generateDots(true);

            var track = carousel.elem.children(".generatedTrack"),
                banners = track.children();

            banners.attr("aria-hidden", "true");
            banners.eq(0).attr("aria-hidden", "false");

            // var $playToggle = $('<a href="javascript:void(0);" class="playToggle playMode" tabindex="0"><span class="inner offscreen">pause</span></a>').click(function () {
            //     var isPlaying = !$playToggle.hasClass("playMode");
            //     if (isPlaying) $playToggle.removeClass("pauseMode").addClass("playMode");
            //     else $playToggle.removeClass("playMode").addClass("pauseMode");
            //     carousel.playToggle();
            // });
            //
            // $(".rm-carousel .dots").append($playToggle);
    	});
    }

    var mod = {
        carousel: null,
        init: init
    };
    return mod;
});

